// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ErrorBoundaryDialogTitle {\r\n  margin-top: 0;\r\n}\r\n\r\n.ErrorBoundaryDialogButton {\r\n  outline: none;\r\n}\r\n\r\n.ErrorBoundaryDialogIcon {\r\n  margin-right: 5px;\r\n  width: 10px;\r\n  -webkit-transform: rotate(-90deg);\r\n          transform: rotate(-90deg);\r\n  vertical-align: middle;\r\n}\r\n\r\n.ErrorBoundaryDialogIcon.opened {\r\n  -webkit-transform: rotate(0deg);\r\n          transform: rotate(0deg);\r\n}\r\n", ""]);
// Exports
module.exports = exports;
